import React from 'react';
import { Navigate } from 'react-router-dom';
import { getDailyManifest } from '../utils/dailyManifest';

// `/daily` → whichever affirmation is today's. Great as a fixed bookmarkable
// URL that always resolves to fresh content.
const DailyRedirect = () => {
  const { theme, index } = getDailyManifest();
  return <Navigate to={`/a/${theme.id}/${index}`} replace />;
};

export default DailyRedirect;
